module.exports = __webpack_public_path__ + "983bf123de1784f4920f07225f65be0b.png";